import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'या पृष्ठाची तक्रार करा',
  title: 'या पृष्ठावरील समस्येची तक्रार करा',
  reasons: {
    'inaccurate-or-fabricated': 'चुकीची किंवा रचलेली माहिती',
    'wrong-product': 'उत्पादने पृष्ठाशी जुळत नाहीत',
    'sexually-explicit': 'लैंगिकदृष्ट्या स्पष्ट मजकूर',
    'regulated-product': 'प्रिस्क्रिप्शनवरील किंवा नियंत्रित उत्पादन',
    'dangerous-product': 'धोकादायक उत्पादन',
    'ip-infringement': 'माझ्या अधिकारांचे उल्लंघन (ट्रेडमार्क/कॉपीराइट)',
    other: 'दुसरे काहीतरी',
  },
  detail: 'तपशील (ऐच्छिक)',
  submit: 'तक्रार पाठवा',
  cancel: 'रद्द करा',
  sent: 'धन्यवाद. आम्ही २४ तासांच्या आत तक्रारी तपासतो.',
  failed: 'तक्रार पाठवता आली नाही. कृपया पुन्हा प्रयत्न करा.',
};
